module.exports = __webpack_public_path__ + "static/ContactHero-c9bbe1bcd9efee6233c8c4e5a7c11ced.jpg";